import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FirebaseRepositoryService } from '../../firebase-repository.service';
import * as PolyUtil from 'google-maps-polyutil';
import { VisorSigpacNgLibComponent } from 'visor-sigpac-ng-lib';

@Component({
  selector: 'ngx-task-detail',
  templateUrl: './task-detail.component.html'
})
export class TaskDetailComponent implements OnInit {

  @Input() task: any;

  @ViewChild('visor') visorsigpac: VisorSigpacNgLibComponent;

  parcela: any;
  mapaListo: boolean = false;

  constructor(private repoService: FirebaseRepositoryService) {}

  ngOnInit() {
    this.cargarDatos();
  }

  ngAfterViewInit() {
    this.mapaListo = true;
    this.tryPintar();
  }

  cargarDatos() {
    if (this.task.field) {
      this.repoService
        .obtenerPacela(this.task.field.userOwner, this.task.field.id)
        .subscribe(parcela => {
          this.parcela = parcela;
          this.tryPintar();
        });
    } else {
      this.tryPintar();
    }
  }

  tryPintar() {
    if (!this.mapaListo) return;
    this.pintarMapa();
  }

  pintarMapa() {
    const elementos: any[] = [];

    // 📍 Inicio
    if (this.task.startLocation) {
      elementos.push({
        geometry: this.task.startLocation,
        properties: { tipo: 'inicio' },
        color: 'rgba(215, 196, 24, 0.84)',
        icon: 'assets/dot-inicio.svg'
      });
    }

    // 📍 Fin
    if (this.task.finishLocation) {
      elementos.push({
        geometry: this.task.finishLocation,
        properties: { tipo: 'fin' },
        color: 'rgba(220, 0, 0, 0.9)',
        icon: 'assets/dot-fin.svg',
        iconAnchor:[0.5,0],
      });
    }

    // 🌾 Parcela
    if (this.parcela) {
      const parcelaGeom = this.generateGeometry(this.parcela.path);
      elementos.push({
        geometry: parcelaGeom,
        properties: this.parcela
      });
      elementos.push({
        geometry: { type: 'Point', coordinates: this.getCentroid(parcelaGeom) },
        properties: { tipo: 'parcela-centro' },
        color: 'rgba(255,255,255,1)',
        icon: 'assets/images/pin.png',
         iconScale: 0.1,
                  iconSize:[32,32],
      });
    }

    const capa = [{
      title: 'Detalle tarea',
      leyenda: false,
      zindex: 1,
      visible: true,
      centrar: true,
      elementos,
      callback: () => {},
      dialogComponent: undefined
    }];

    this.visorsigpac.cargarCapas(capa);

    setTimeout(() => {
      (this.visorsigpac as any).invalidateSize?.();
      (this.visorsigpac as any).redraw?.();
    }, 300);
  }

  getCentroid(geometry: any): number[] {
    const coords: number[][] = geometry.coordinates[0];
    const n = coords.length;
    const lon = coords.reduce((sum, c) => sum + c[0], 0) / n;
    const lat = coords.reduce((sum, c) => sum + c[1], 0) / n;
    return [lon, lat];
  }

  generateGeometry(path: string): any {
    if (!path) return { type: 'Polygon', coordinates: [[]] };

    const geometry = {
      type: 'Polygon',
      coordinates: [[]] as number[][][]
    };

    let coords = PolyUtil.decode(path).reverse();

    coords.forEach(coordp => {
      geometry.coordinates[0].push([coordp.longitude, coordp.latitude]);
    });

    return geometry;
  }
}
